// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-0627c8ae],html[data-v-0627c8ae]{overflow:hidden}.blog-layout__header[data-v-0627c8ae]{position:absolute;top:0;left:0;width:100%;z-index:100;height:5rem;background:#fff}.blog-layout__body[data-v-0627c8ae]{display:block;overflow:hidden}.blog-layout__body__content[data-v-0627c8ae]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
